import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { FaChalkboardTeacher } from "react-icons/fa";

function GreetingIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading title={"Greeting"} icon={<FaChalkboardTeacher size={50} />} />
        <IncomeCard
          title={"Total"}
          amount={props?.greetingTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.greetingDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.greetingWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.greetingMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.greetingYearlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default GreetingIncome;
